import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { AssociateAgentResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { asUpdateHook, buildSelectParam, get, post, postEmpty } from "./common";

export const associateAgent = {
    record(data: typeof Requests.AssociateAgent.Record.Input) {
        return post<typeof data, AssociateAgentResponseTypes.Record>(
            `/associate-agent/record`,
            data,
        );
    },
    subscriptionRecord(id: string) {
        return (data: typeof Requests.AssociateAgent.SubscriptionRecord.Input) => {
            return post<typeof data, AssociateAgentResponseTypes.SubscriptionRecord>(
                `/associate-agent/subscription-record/${id}`,
                data,
            );
        };
    },
    invoiceRecord(id: string) {
        return (data: typeof Requests.AssociateAgent.InvoiceRecord.Input) => {
            return post<typeof data, AssociateAgentResponseTypes.InvoiceRecord>(
                `/associate-agent/invoice-record/${id}`,
                data,
            );
        };
    },
    settlementRecord(id: string) {
        return (data: typeof Requests.AssociateAgent.SettlementRecord.Input) => {
            return post<typeof data, AssociateAgentResponseTypes.SettlementRecord>(
                `/associate-agent/settlement-record/${id}`,
                data,
            );
        };
    },
    create(data: typeof Requests.AssociateAgent.Create.Input) {
        return post<typeof data>(`/associate-agent/create`, data);
    },
    delete(id: string) {
        return postEmpty(`/associate-agent/delete/${id}`);
    },
    obtain(id: string) {
        return get<AssociateAgentResponseTypes.Obtain>(`/associate-agent/obtain/${id}`);
    },
    formHooks: {
        select: (async (param?: SelectParam) => {
            const req = get<AssociateAgentResponseTypes.Select>(
                `/associate-agent/select` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        selectCandidate: (async (param?: SelectParam) => {
            const req = get<AssociateAgentResponseTypes.SelectCandidate>(
                `/associate-agent/select-candidate` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.AssociateAgent.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/associate-agent/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
    dev: {
        masquerade(id: string) {
            return get<AssociateAgentResponseTypes.Masquerade>(
                `/dev/associate-agent/masquerade/${id}`,
            );
        },
    },
};
